import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const borderStyle = `1px solid ${colorsPalettes.carbon[100]}`;

export const StyledHeaderContainer = styled.div`
    padding: 16px;
    border-bottom: ${borderStyle};
`;

export const ShareBlockContainer = styled(Stack)`
    gap: 32px;
    width: 50%;
    padding: 48px 16px 24px;
    border-right: ${borderStyle};
`;

export const PeriodContainer = styled(Stack)`
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-grow: 1;

    &:not(:last-of-type) {
        border-bottom: ${borderStyle};
    }
`;

export const ValueContainer = styled(Stack)`
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

export const ShareValue = styled.span`
    ${setFontVariant("h3", colorsPalettes.carbon[500])}
`;

export const StyledText = styled.span`
    ${setFontVariant("subTitle3Alt", colorsPalettes.carbon[500])}
`;

export const TrendsBlockContainer = styled.div`
    width: 100%;
`;

export const LoaderWrapper = styled(Flex)`
    width: 100%;
    height: 162px;
    justify-content: center;
    align-items: center;
`;
